import React, { useEffect, useState } from "react";
import kukrejaLogo from "../../images/kukrejaLogo.png";
import check from "../../images/check.gif";
import { Calendar, Phone, User } from "react-feather";
import { useNavigate, useParams } from "react-router-dom";
import PrimaryButton from "../../components/infrastructure/Buttons/PrimaryButton";
import QueryString from "qs";
import { authAxiosInstance } from "../../utils/axiosConfig";
import moment from "moment";
import celebration from "../../images/Celebtraion.gif";

const ThankYouPage = () => {
  const { eventId } = useParams();
  console.log("parama id", eventId);
  const [eventData, setEventData] = useState({});

  console.log("eventData", eventData);
  const navigate = useNavigate();

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const fetchCustomerMeetingData = async (id) => {
    const string = QueryString.stringify({ _id: id });
    const resp = await authAxiosInstance.get(
      `/calenderEvent/forCustomer?${string}`
    );
    console.log("resp???", resp?.data);
    setEventData(resp?.data?.data[0]);
  };

  useEffect(() => {
    if (eventId) {
      fetchCustomerMeetingData(eventId);
    }
  }, [eventId]);

  return (
    <div className="p-4 bg-white w-full h-screen">
      <div className="flex bg-transparent z-30 fixed items-center justify-center h-screen w-screen pointer-events-none">
        <img
          className="h-full w-full lg:w-[60%]"
          src={celebration}
          alt="thankYou"
        />
      </div>
      <div className="flex items-center justify-center gap-4">
        <img
          src={kukrejaLogo}
          alt="kukrejaLogo"
          className=" w-[40%] md:w-[25%] lg:w-[15%]"
        />
      </div>
      <div className="flex flex-row items-center justify-center gap-2 py-4 lg:pt-1 lg:pb-4 ">
        <p className="text-blue-950 ">Manish is Schedule for you</p>
        <img src={check} alt="schedule" className="w-[36px] h-[36px]" />
      </div>
      <div className="border border-gray-200 rounded-lg p-4 w-full md:w-[60%] lg:w-[40%] flex flex-col gap-4 mx-auto">
        <h1 className="text-xl text-blue-950">15 Minute Meeting</h1>
        <p className="flex flex-row gap-1 items-center text-xs md:text-xl text-stone-500">
          <User size={22} className="mr-1" /> Manish S. Kukreja
        </p>
        <p className="flex flex-row gap-1 items-center text-xs md:text-xl text-stone-500">
          <Calendar size={22} className="mr-1" />
          {`${formatTime(eventData?.start)} - ${formatTime(
            eventData?.end
          )}, ${moment(eventData?.start).format("dddd, MMMM D, YYYY")}`}
        </p>
        <p className="flex flex-row gap-1 items-center text-xs md:text-xl text-stone-500">
          <Phone size={18} className="mr-1" /> +91 93745 02575
        </p>
      </div>
      <div className="p-4 text-center">
        <PrimaryButton
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            console.log("click");
            navigate(-1);
          }}
        >
          Ok
        </PrimaryButton>
      </div>
    </div>
  );
};

export default ThankYouPage;
